import { createContext, useContext } from "react"

const Context = createContext()

const useDealer = () => {
  return useContext(Context).dealer
}

const useDealerName = () => {
  return useContext(Context).dealerName
}

const useEstablishment = () => {
  return useContext(Context).establishment
}
// const useServiceCenter = () => {
//   return useContext(Context).serviceCenter
// }

const useMeta = () => {
  return useContext(Context).meta
}

const useRSWI = () => {
  return useContext(Context).rswi
}

const RetailerCTX = ({ children, dealerName, rswi, dealer, establishment, /*serviceCenter,*/ meta }) => {
  return <Context.Provider value={{ dealerName, rswi, dealer, establishment, /*serviceCenter,*/ meta }}>{children}</Context.Provider>
}

export default RetailerCTX
export { useDealer, useDealerName, useEstablishment, /*useServiceCenter,*/ useMeta, useRSWI }
